import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import "./index.css";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import { store, persistor } from "./store/store";
import { PersistGate } from "redux-persist/integration/react";
import "antd/dist/antd.css";
import "./fonts/PFDinTextPro-Bold.ttf";
import "./fonts/PFDinTextPro-Regular.ttf";
import "./fonts/PFDinTextPro-Bold.woff";
import "./fonts/PFDinTextPro-Regular.woff";
//import "./out.css";

ReactDOM.render(
  <Provider store={store}>
    <PersistGate persistor={persistor} loading={null}>
      <App />
    </PersistGate>
  </Provider>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
